import React from 'react';
import { bem } from '../../../../core/bem';
import { FlightStep } from '../../flight.types';
import { computeDuration } from '../../utils/flightUtils';
import './FlightOption.scss';

const css = bem('FlightOption');

interface FlightOptionProps {
  flight: FlightStep;
  onSelect: (flight: FlightStep) => void;
}

export const FlightOption = ({ flight, onSelect }: FlightOptionProps) => {
  const { departureTime, departureAirport, departureAirportCode, arrivalTime, arrivalAirport, arrivalAirportCode, isoDuration } = flight;
  return (
    <div className={css()} onClick={() => onSelect(flight)}>
      <div className={css('departure')}>
        <div className={css('circle-and-divider')}>
          <div className={css('circle')} />
          <div className={css('divider')} />
        </div>
        <div className={css('infos')}>
          <span className="time">{departureTime}</span> : <span className="airport">{departureAirport}</span> ({departureAirportCode})
          <div className="duration">{computeDuration(isoDuration!)}</div>
        </div>
      </div>
      <div className={css('arrival')}>
        <div className={css('circle')} />
        <div className={css('infos')}>
          <span className="time">{arrivalTime}</span> : <span className="airport">{arrivalAirport}</span> ({arrivalAirportCode})
        </div>
      </div>
    </div>
  );
};
